<div class="wrap">
    <ul class="nationality-ranking head">
        <li>
            <span class="rank">{{ 'rank' | translate }}</span>
            <span class="country">{{ 'MobileCountry' | translate }}</span>
            <span class="gold">{{ 'LeaveTablePenalty1st' | translate }}</span>
            <span class="silver">{{ 'LeaveTablePenalty2nd' | translate }}</span>
            <span class="bronze">{{ 'LeaveTablePenalty3rd' | translate }}</span>
            <span class="total-winnings">{{ 'TotalWinnings' | translate }}</span>
            <span class="prize">{{ 'RewardsTab' | translate }}</span>
            <span class="date">{{ 'FreerollDate' | translate }}</span>
        </li>
    </ul>
    <div *ngIf="isMaintenance" class="maintenance">
        <p [innerHTML]="'maintenance_desc01' | translate">Currently under maintenance.</p>
        <p [innerHTML]="'maintenance_desc02' | translate">Please check back shortly.</p>
    </div>
    <div *ngIf="!isMaintenance && (0 === topList.length && 0 === bottomList.length)" class="maintenance">
        {{ 'dataEmpty' | translate }}
    </div>
    <div class="top-ranking" *ngIf="!isMaintenance && topList && 0 < topList.length">
        <ul class="nationality-ranking top">
            <li *ngFor="let item of topList; let i = index">
                <span class="rank">{{ item.rank }}</span>
                <span class="country">
                    <img src="/assets/static/leaderboard/img/country/{{ item.displayCountryId }}.png">
                    <span class="full">{{ 'CountryName_' + item.nationality | translate }}</span>
                    <span class="ioc">{{ item.displayIocCountryId }}</span>
                </span>
                <span class="gold">{{ item.gold }}</span>
                <span class="silver">{{ item.silver }}</span>
                <span class="bronze">{{ item.bronze }}</span>
                <span class="total-winnings">${{ item.totalWinning | number }}</span>
                <span class="prize">
                    <span class="amount">{{ item.displayPrize }}</span>
                    <span class="freeroll" *ngIf="item.prize">{{ 'FreerollText' | translate }}</span>
                </span>
                <span class="date">{{ item.prizePaidAt | date: 'LLL d' }}</span>
            </li>
        </ul>
        <div class="box"><div class="box-inner"></div></div>
    </div>
    <ul class="nationality-ranking bottom" *ngIf="!isMaintenance && bottomList && 0 < bottomList.length">
        <li *ngFor="let item of bottomList; let i = index">
            <span class="rank">{{ item.rank }}</span>
            <span class="country">
                <img src="/assets/static/leaderboard/img/country/{{ item.displayCountryId }}.png">
                <span class="full">{{ 'CountryName_' + item.nationality | translate }}</span>
                <span class="ioc">{{ item.displayIocCountryId }}</span>
            </span>
            <span class="gold">{{ item.gold }}</span>
            <span class="silver">{{ item.silver }}</span>
            <span class="bronze">{{ item.bronze }}</span>
            <span class="total-winnings">${{ item.totalWinning | number }}</span>
            <span class="prize">
                <span class="amount">{{ item.displayPrize }}</span>
                <span class="freeroll" *ngIf="item.prize">{{ 'FreerollText' | translate }}</span>
            </span>
            <span class="date">{{ item.prizePaidAt | date: 'LLL d' }}</span>
        </li>
    </ul>
</div>

<div class="loadingArea" *ngIf="progress"></div>

